import axios from 'axios'

const ReceivingService = {
  async get (params = {}) {
    return axios.get('wo/purchase-order/receivings', { params })
  },

  async histories (params = {}) {
    return axios.get('wo/reports/purchase-order/receiving-histories', { params })
  },

  async exports (params = {}) {
    return axios.get('wo/exports/purchase-order/receivings', { params })
  },

  async show (id) {
    return axios.get(`wo/purchase-order/receivings/${id}`)
  },

  async post (params = {}) {
    return axios.post('wo/purchase-order/receivings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`wo/purchase-order/receivings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`wo/purchase-order/receivings/${data.id}`, { data })
  }
}

export default ReceivingService
